import classNames from 'classnames';
import { useCallback, useMemo } from 'react';
import * as React from 'react';
import AccordionContext from './AccordionContext';

type AccordionGroupProps = React.PropsWithChildren<{
    value: string[];
    onChange: (value: string[]) => void;
    allowMultipleExpanded?: boolean;
    className?: string;
}>;

export default function AccordionGroup({
    children,
    value,
    onChange,
    allowMultipleExpanded = false,
    className = '',
}: AccordionGroupProps) {
    const expanded = useCallback((id: string) => value.includes(id), [value]);

    const toggleExpanded = useCallback((id: string) => {
        if (value.includes(id)) {
            onChange(value.filter(i => i !== id));
        } else if (allowMultipleExpanded) {
            onChange([...value, id]);
        } else {
            onChange([id]);
        }
    }, [allowMultipleExpanded, onChange, value]);

    const contextValue = useMemo(() => ({ expanded, toggleExpanded }), [expanded, toggleExpanded]);

    return (
        <AccordionContext.Provider
            value={contextValue}
        >
            <div className={classNames('palette-accordion', className)}>
                { children }
            </div>
        </AccordionContext.Provider>
    );
}
